import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import "../assets/style/PreloadSelectRoutes.css";
import Logo from "../assets/images/preload.png";
import { API_ENDPOINTS } from "../api/endpoints";
import { useTheme } from "../hooks/useTheme";

const SelectRoutes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { theme } = useTheme();
  useEffect(() => {
    const token = Cookies.get("token");
    const userId = Cookies.get("userId");
    const userName = Cookies.get("userName");

    if (!token || !userId) {
      navigate("/"); // No autenticado
      return;
    }

    const waitMinTime = new Promise((resolve) => setTimeout(resolve, 2000));

    const validateUser = fetch(API_ENDPOINTS.interna.validate_user, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ userId: userName }),
    }).then((res) => res.json());

    // Esperar ambos en paralelo
    Promise.all([waitMinTime, validateUser])
      .then(([, data]) => {
        if (data.es_superusuario === true) {
          navigate("/admin/AdminHome");
        } else if (data.es_superusuario === false) {
          navigate("/panel/Home");
        } else {
          navigate("/");
        }
      })
      .catch((err) => {
        console.error("Error al validar rol:", err);
        navigate("/");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  if (loading)
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <div className="spinnerContainer">
          <div className="spinner mb-3"></div>
          <div className="preloader">
            <img src={Logo} alt="Logo Ecotrans" />
            <span className="font-ecotrans text-verde">Eco</span>
            <span className={`font-ecotrans ${theme === "light" ? "text-negro" : "text-white"}`}>trans</span>
            <div className="words">
              <span className="word">Seguridad</span>
              <span className="word">Puntualidad</span>
              <span className="word">Confiabilidad</span>
              <span className="word">Comodidad</span>
              <span className="word">Flexibilidad</span>
            </div>
          </div>
        </div>
      </div>
    );
  return null;
};

export default SelectRoutes;
